<template>
    <div class="breadcrumb">
        <div class="content">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>

                <el-breadcrumb-item :to="{ path: '/news' }">新闻资讯</el-breadcrumb-item>
                <el-breadcrumb-item class="font-weight" v-if="navBarLabel">{{navBarLabel}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

    </div>
</template>

<script>
export default {
    props: {
        navBarLabel: {
            type: String,
            default: '',
        },
    },
    data() {
        return {};
    },
    methods: {},
    mounted() {},
};
</script>

<style lang="scss" scoped>
@import '@css/var.scss';

.breadcrumb {
    height: 60px;
    display: flex;
    align-items: center;
    // margin: 10px 0 20px;
    .content {
        color: #979797;

        // background-color: #fff;
        // height: 100%;
        padding-left: 20px;
        // display: flex;
        // align-items: center;

        ::v-deep .el-breadcrumb__inner.is-link,
        ::v-deep .el-breadcrumb__inner a {
            font-weight:400;
            color: #979797;
        }
        
        ::v-deep .el-breadcrumb__inner{
            font-weight:bold;
            color: #383838;
        }
    }
}
</style>